import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Mix } from '@ant-design/plots';
import insertCss from 'insert-css';
import styles from './index.module.scss';

const BloodChart = ({ BloodChartObj, chartType, chartDate }) => {
  const [data, setData] = useState([]);
  const fontSize = window.innerWidth > 500 ? 25 : 15;
  const size = window.innerWidth > 500 ? 8 : 4;
  useEffect(() => {
    const week = ['一', '二', '三', '四', '五', '六', '日'];
    const ChartValue = [];
    if (chartType === 'week') {
      const BloodFilter = BloodChartObj.filter(
        (item) =>
          item.createTime >= moment(chartDate).startOf('W').valueOf() &&
          item.createTime <= moment(chartDate).endOf('W').valueOf()
      );

      for (let i = 0; i < week.length; i++) {
        const BloodWeek = BloodFilter.filter((item) => item.week === i);
        if (BloodWeek.length === 0) {
          ChartValue[i] = { date: week[i] };
        } else {
          ChartValue[i] = { ...BloodWeek[0] };
          ChartValue[i].date = week[i];
        }
      }
      setData(ChartValue);
    } else if (chartType === 'month') {
      const month = moment(chartDate).format('MMMM');
      const monthEnd = moment(chartDate).endOf('month').date();

      const BloodFilter = BloodChartObj.filter(
        (item) => moment(item.createTime).format('MMMM') === month
      );
      for (let i = 0; i < monthEnd; i++) {
        const BloodMonth = BloodFilter.filter(
          (item) => moment(item.createTime).date() === i + 1
        );
        if (BloodMonth.length === 0) {
          ChartValue[i] = { date: (i + 1).toString() };
        } else {
          ChartValue[i] = { ...BloodMonth[0] };
          ChartValue[i].date = (i + 1).toString();
        }
      }
      setData(ChartValue);
    } else if (chartType === 'date') {
      const BloodFilter = BloodChartObj.filter(
        (item) =>
          moment(item.createTime).format('YYYY/MM/DD') ===
          moment(chartDate).format('YYYY/MM/DD')
      );
      console.log(BloodFilter);
      for (let i = 0; i < 24; i++) {
        const BloodDay = BloodFilter.filter(
          (item) => parseInt(moment(item.createTime).format('HH'), 10) === i
        );
        if (BloodDay.length === 0) {
          if (i === 23) {
            ChartValue[i] = { date: '23:59' };
          } else {
            ChartValue[i] = { date: `${i}:00` };
          }
        } else {
          ChartValue[i] = { ...BloodDay[0] };
          if (i === 23) {
            ChartValue[i].date = '23:59';
          } else {
            ChartValue[i].date = `${i}:00`;
          }
        }
      }
      setData(ChartValue);
    }
  }, [BloodChartObj, chartType, chartDate]);

  insertCss(`
    .custom-tooltip-title {
        margin: 0px 12px;
        padding: 10px 0 8px;
        font-size: 12px;
        border-bottom-style: solid;
        border-bottom-width: thin;
        border-bottom-color: #e9e9e9;
    }

    .custom-tooltip-value {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin: 8px 12px 0 12px;
      padding-bottom: 8px;
      font-size: 25px;
      text-align: center;
      border-bottom-style: solid;
      border-bottom-width: thin;
      border-bottom-color: #e9e9e9;
      height: 70px;
    }

    .custom-tooltip-temp {
      display: flex;
      position: relative;
      align-items: center;
    }

    .custom-tooltip-temp span:first-child {
      font-size: 12px;
      position: absolute;
      top: 0px;
      color: rgba(0, 0, 0, 0.45)
    }

    .custom-tooltip-temp span:last-child {
      text-align: left;
      margin-top: 10px;
      position: relative;
      color: rgba(0, 0, 0, 0.85)
    }

    .custom-tooltip-wind {
        margin: 8px 12px 12px 12px;
        font-size: 10px;
        color: rgba(0, 0, 0, 0.45);
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .tooltip-footer {
      margin: 8px 12px 12px 12px;
      font-size: 10px;
      color: rgba(0, 0, 0, 0.45);
    }

    .background-image {
      background-repeat: no-repeat;
    }

    .rain {
        background-image: url(https://gw.alipayobjects.com/mdn/rms_2274c3/afts/img/A*sg5aT7dY36wAAAAAAAAAAABkARQnAQ);
    }

    .sun {
        background-image: url(https://gw.alipayobjects.com/mdn/rms_2274c3/afts/img/A*gE_hS5JVl5YAAAAAAAAAAABkARQnAQ);
    }

    .cloud {
        background-image: url(https://gw.alipayobjects.com/mdn/rms_2274c3/afts/img/A*BTw4R4O341AAAAAAAAAAAABkARQnAQ);
    }
`);
  const config = {
    tooltip: {
      showMarkers: false,
      enterable: true,
      domStyles: {
        'g2-tooltip': {
          width: '150px',
          padding: 0,
        },
      },
      customContent: (title, items) => {
        const data = items[0]?.data || {};
        let titleDom = '';
        if (chartType === 'month' || chartType === 'week') {
          if (data?.num === 1) {
            titleDom = `<div class ="custom-tooltip-title">${moment(
              data.createTime
            ).format('YYYY/MM/DD')}</div>`;
          } else {
            titleDom = `<div class ="custom-tooltip-title">${moment(
              data.createTime
            ).format('YYYY/MM/DD')}(平均)</div>`;
          }
        } else {
          titleDom = `<div class ="custom-tooltip-title">${moment(
            data.createTime
          ).format('MM/DD HH:mm')}</div>`;
        }

        const tempDom = `<div class = "custom-tooltip-value"><div class = "custom-tooltip-temp"><span>收縮壓</span><span>${data.maxTemp}</span></div><div class = "custom-tooltip-temp"><span>舒張壓</span><span>${data.minTemp}</span></div></div>`;
        const windDom = `<div class = "custom-tooltip-value"><div class = "custom-tooltip-temp"><span>脈拍數</span><span>${data.heart}</span></div></div>`;

        return `<div class="">${titleDom}${tempDom}${windDom}</div>`;
      },
    },
    views: [
      {
        data: data.map((d) => {
          return { ...d, values: [d.minTemp, d.maxTemp] };
        }),

        meta: {
          date: {
            sync: true,
            range: [0, 1],
            tickCount: chartType === 'date' && 5,
          },

          minTemp: {
            min: 0,
            max: 200,
            label: {
              style: {
                fontSize,
              },
            },
          },
          maxTemp: {
            min: 0,
            max: 200,
            label: {
              style: {
                fontSize,
              },
            },
          },
          values: {
            min: 0,
            max: 200,
            label: {
              style: {
                fontSize,
              },
            },
          },
          heart: {
            min: 0,
            max: 200,
            label: {
              style: {
                fontSize,
              },
            },
          },
        },

        axes: {
          date: {
            label: {
              style: {
                fontSize,
              },
            },
          },
          minTemp: false,
          maxTemp: false,
          heart: {
            label: {
              formatter: () => '  ',
            },
          },
          values: {
            position: 'left',
            label: {
              style: {
                fontSize,
              },
              formatter: (v) => `${v}  `,
            },
          },
        },
        interactions: [
          {
            type: 'active-region',
          },
        ],

        geometries: [
          {
            type: 'interval',
            xField: 'date',
            yField: 'values',
            mapping: {
              size: size / 2,
              style: {
                fill: '#69B49E',
              },
            },
          },
          {
            type: 'point',
            xField: 'date',
            yField: 'minTemp',
            colorField: 'maxTemp',
            mapping: {
              style: {
                stroke: '#69B49E',
                fill: '#F0EEEF',
                lineWidth: 2,
              },
              size,
              shape: 'hollow-circle',
              color: ['#69B49E'],
            },
          },
          {
            type: 'point',
            xField: 'date',
            yField: 'maxTemp',
            colorField: 'maxTemp',
            mapping: {
              style: {
                stroke: '#69B49E',
              },
              size,
              shape: 'circle',
              color: ['#69B49E'],
            },
          },
          {
            type: 'point',
            xField: 'date',
            yField: 'heart',
            colorField: 'heart',
            mapping: {
              style: {
                stroke: '#b57070',
              },

              size,
              shape: 'circle',
              color: ['#b57070'],
            },
          },
        ],
        annotations: [
          // 最高值

          {
            type: 'line',
            start: ['min', '135'],
            end: ['max', '135'],
            text: {
              content: '最高舒張壓',
              style: {
                textAlign: 'left',
                fontSize,
                fill: 'rgba(255, 0, 0, 0.25)',
                textBaseline: 'bottom',
                lineDash: [2, 2],
              },
            },
            top: false,
            style: {
              stroke: 'rgba(255, 0, 0,0.25)',
              lineWidth: 2,
              lineDash: [4, 5],
            },
          },
          {
            type: 'line',
            start: ['min', '85'],
            end: ['max', '85'],
            text: {
              content: '最高收縮壓',
              style: {
                textAlign: 'left',
                fontSize,
                fill: 'rgba(255, 0, 0, 0.25)',
                textBaseline: 'bottom',
                lineDash: [2, 2],
              },
            },
            top: false,
            style: {
              stroke: 'rgba(255, 0, 0, 0.25)',
              lineWidth: 2,
              lineDash: [4, 5],
            },
          },
        ],
      },
    ],
  };
  return (
    <>
      {/* <div className={styles.chartTitleText}>血壓量測紀錄</div> */}
      <div className={styles.chartBox}>
        <Mix {...config} />
      </div>
      <div className={styles.chartLegend}>
        <div className={styles.bloodLegend1} />
        舒張壓
        <div className={styles.bloodLegend2} />
        收縮壓
        <div className={styles.bloodLegend3} />
        脈拍數
      </div>
    </>
  );
};

export default BloodChart;
